/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthSubmissionErrorType = {
    InternalError: 'INTERNAL_ERROR',
    RemotePatientNotFound: 'REMOTE_PATIENT_NOT_FOUND',
    PatientWithMultipleEncounters: 'PATIENT_WITH_MULTIPLE_ENCOUNTERS',
    ContinuedStayRequestUnavailable: 'CONTINUED_STAY_REQUEST_UNAVAILABLE',
    VoidedByPlatform: 'VOIDED_BY_PLATFORM',
    WithdrawnByPlatform: 'WITHDRAWN_BY_PLATFORM',
} as const;
export type PalReauthSubmissionErrorType = typeof PalReauthSubmissionErrorType[keyof typeof PalReauthSubmissionErrorType];


export function instanceOfPalReauthSubmissionErrorType(value: any): boolean {
    for (const key in PalReauthSubmissionErrorType) {
        if (Object.prototype.hasOwnProperty.call(PalReauthSubmissionErrorType, key)) {
            if (PalReauthSubmissionErrorType[key as keyof typeof PalReauthSubmissionErrorType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthSubmissionErrorTypeFromJSON(json: any): PalReauthSubmissionErrorType {
    return PalReauthSubmissionErrorTypeFromJSONTyped(json, false);
}

export function PalReauthSubmissionErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionErrorType {
    return json as PalReauthSubmissionErrorType;
}

export function PalReauthSubmissionErrorTypeToJSON(value?: PalReauthSubmissionErrorType | null): any {
    return value as any;
}

export function PalReauthSubmissionErrorTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthSubmissionErrorType {
    return value as PalReauthSubmissionErrorType;
}

